var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsAndGuides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tips_and_guides") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tips-2",
    "data-name": "tips"
  }, /*#__PURE__*/React.createElement("g", {
    id: "videos"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.98,
    y: 232.97,
    width: 198.61,
    height: 97.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.09,
    y: 198.22,
    width: 229.39,
    height: 39.72,
    rx: 10,
    ry: 10,
    style: {
      fill: "#be9ff1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.09,
    y: 327.31,
    width: 229.39,
    height: 39.72,
    rx: 10,
    ry: 10,
    style: {
      fill: "#be9ff1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.61,
    y: 272.7,
    width: 168.82,
    height: 19.86,
    rx: 6.75,
    ry: 6.75,
    transform: "translate(644.65 -79.4) rotate(90)",
    style: {
      fill: "#be9ff1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.15,
    y: 272.7,
    width: 168.82,
    height: 19.86,
    rx: 6.75,
    ry: 6.75,
    transform: "translate(854.18 -288.93) rotate(90)",
    style: {
      fill: "#be9ff1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.72,276,452.25,250.3a4.88,4.88,0,0,0-7.31,4.22v51.35a4.88,4.88,0,0,0,7.31,4.22l44.47-25.67A4.88,4.88,0,0,0,496.72,276Z",
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.95,
    y: 209.14,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.66,
    y: 209.14,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.38,
    y: 209.14,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 209.14,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.8,
    y: 209.14,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.95,
    y: 337.24,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.66,
    y: 337.24,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.38,
    y: 337.24,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 337.24,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.8,
    y: 337.24,
    width: 23.83,
    height: 17.87,
    rx: 5,
    ry: 5,
    style: {
      fill: "#a00ce8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527,397.31V557.77H72.86V397.31l8,.47q56.42,3.2,116.8,4.86,39.74,1.07,81.09,1.3c4.42.05,8.87.06,13.32.06h.23c2.22,0,4.45,0,6.69,0h3.16c2,0,4,0,6,0h2q53-.15,103.36-1.66,54.24-1.59,105.37-4.57h0C521.63,397.63,524.31,397.46,527,397.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527,405.27V562.63a4.25,4.25,0,0,1-.2,1.33,5,5,0,0,1-.63,1.44c-1.67,2.71-5.71,4.83-10.92,5.52l-41.49,5.61-49.23,6.66-19.14,2.58h-.06L304,599.46a25.07,25.07,0,0,1-4.07.23,22.88,22.88,0,0,1-3.21-.23L84.62,570.92c-6.9-.92-11.76-4.36-11.76-8.29V405.27c0-3.22,3.24-6,8-7.49a25.38,25.38,0,0,1,7.37-1H511.6a25.52,25.52,0,0,1,7.34,1h0C523.74,399.22,527,402,527,405.27Z",
    style: {
      fill: "#bfebff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.13,446.72l-2,.35L527,454.44,399.7,476.22c-6.77,1.15-14.09-.41-17.74-3.78l-21.41-19.85-2.36-2.19-50-46.4-6-5.57h0l-1.8-1.67h0l102.31-7.42,1.91-.14,116.51-8.44c6.51-.47,12.84,1.39,15.76,4.64l44.51,49.37C585.62,439.47,581.23,445.18,572.13,446.72Z",
    style: {
      fill: "#28d6e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.59,476.22,28.15,446.73c-9.09-1.55-13.48-7.26-9.23-12l44.5-49.37c2.93-3.25,9.26-5.12,15.76-4.65l220.75,16-81.6,75.7C214.69,475.82,207.36,477.38,200.59,476.22Z",
    style: {
      fill: "#28d6e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.13,446.72l-2,.35L527,454.44V562.63a4.25,4.25,0,0,1-.2,1.33,5,5,0,0,1-.63,1.44c-1.67,2.71-5.71,4.83-10.92,5.52l-41.49,5.61-49.23,6.66-19.14,2.58h-.06L304,599.46a25.07,25.07,0,0,1-4.07.23v-203h.44l102.31-7.42,1.91-.14,116.51-8.44c6.51-.47,12.84,1.39,15.76,4.64l44.51,49.37C585.62,439.47,581.23,445.18,572.13,446.72Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "guidebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247,150.74v212a5.8,5.8,0,0,1-5.8,5.79H61.39V145.35a.41.41,0,0,1,.42-.41H241.15A5.8,5.8,0,0,1,247,150.74Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.29,
    y: 144.8,
    width: 29.81,
    height: 223.56
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 105.54,
    y: 191.3,
    width: 122.73,
    height: 21.61,
    rx: 5,
    ry: 5,
    style: {
      fill: "#7796ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.54,
    y: 234.52,
    width: 122.73,
    height: 21.61,
    rx: 5,
    ry: 5,
    style: {
      fill: "#7796ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.54,
    y: 277.74,
    width: 122.73,
    height: 21.61,
    rx: 5,
    ry: 5,
    style: {
      fill: "#7796ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "lightbulb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.1,260.88V272.4a5,5,0,0,1-5,5H268.4a5,5,0,0,1-5-5V260.88Z",
    style: {
      fill: "#ffa068"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,310.44v3.26a5,5,0,0,1-5,5h-33a5,5,0,0,1-5-5v-3.26Z",
    style: {
      fill: "#ffa068"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.4,
    y: 277.4,
    width: 72.7,
    height: 16.52,
    rx: 5,
    ry: 5,
    style: {
      fill: "#ffa068"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.71,
    y: 293.92,
    width: 66.09,
    height: 16.52,
    rx: 5,
    ry: 5,
    style: {
      fill: "#ffa068"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.75,79.13c-7.87-.16-34.6.28-57.82,19.83-19.08,16.05-33,42.66-29.74,69.39a78.06,78.06,0,0,0,11.56,31.39c9.4,14.35,18.71,17.11,28.09,31.4a75.57,75.57,0,0,1,11.26,29.74h36.65Z",
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32,168.35a78.06,78.06,0,0,1-11.56,31.39c-9.4,14.35-18.71,17.11-28.09,31.4a75.61,75.61,0,0,0-11.27,29.74H299.75V79.13c7.88-.16,34.61.28,57.83,19.83C376.65,115,390.6,141.62,387.32,168.35Z",
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.26,
    y: 158.44,
    width: 56.8,
    height: 21.3,
    rx: 7.04,
    ry: 7.04,
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.44,
    y: 158.44,
    width: 56.8,
    height: 21.3,
    rx: 7.04,
    ry: 7.04,
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.96,
    y: 65.04,
    width: 42.6,
    height: 21.3,
    rx: 7.04,
    ry: 7.04,
    transform: "translate(60.78 298.13) rotate(-45)",
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.34,
    y: 65.04,
    width: 42.6,
    height: 21.3,
    rx: 7.04,
    ry: 7.04,
    transform: "translate(113.76 -123.24) rotate(45)",
    style: {
      fill: "#fffb51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.22,
    y: 21.4,
    width: 56.8,
    height: 21.3,
    rx: 7.04,
    ry: 7.04,
    transform: "translate(331.68 -267.57) rotate(90)",
    style: {
      fill: "#fffb51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,277.4a5,5,0,0,1,5,5v6.52a5,5,0,0,1-5,5h-3.3a5,5,0,0,1,5,5v6.52a5,5,0,0,1-5,5h-6.57v3.26a5,5,0,0,1-5,5H299.75V260.88H336.1V272.4A5,5,0,0,1,331.1,277.4Z",
    style: {
      opacity: 0.07
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsAndGuides);
export default __webpack_public_path__ + "static/media/tips_and_guides.427a64a9574d70387c9f507c116e36e2.svg";
export { ForwardRef as ReactComponent };